"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconClose = require("../Icons/IconClose");

var _IconClose2 = _interopRequireDefault(_IconClose);

var _IconWarning = require("../Icons/IconWarning");

var _IconWarning2 = _interopRequireDefault(_IconWarning);

var _IconComplete = require("../Icons/IconComplete");

var _IconComplete2 = _interopRequireDefault(_IconComplete);

var _IconError = require("../Icons/IconError");

var _IconError2 = _interopRequireDefault(_IconError);

var _IconInfoOutline = require("../Icons/IconInfoOutline");

var _IconInfoOutline2 = _interopRequireDefault(_IconInfoOutline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** Banners showing status messages */
var Alert = function (_React$Component) {
  _inherits(Alert, _React$Component);

  function Alert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Alert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Alert.__proto__ || Object.getPrototypeOf(Alert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: true
    }, _this.handleCloseClick = function () {
      _this.setState({ isOpen: false });
      if (_this.props.onCloseClick) _this.props.onCloseClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alert, [{
    key: "renderIcon",
    value: function renderIcon(type) {
      switch (type) {
        case "success":
          return _react2.default.createElement(_IconComplete2.default, null);
        case "warning":
          return _react2.default.createElement(_IconWarning2.default, null);
        case "danger":
          return _react2.default.createElement(_IconError2.default, null);
        case "info":
          return _react2.default.createElement(_IconInfoOutline2.default, null);
        default:
          return "";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          type = _props.type,
          displayCloseButton = _props.displayCloseButton,
          children = _props.children,
          htmlId = _props.htmlId;

      if (!this.state.isOpen) return null;
      return _react2.default.createElement(
        "div",
        { id: htmlId, className: "cx-alert cx-alert__" + type },
        _react2.default.createElement(
          "div",
          { className: "cx-alert__icon" },
          this.renderIcon(type)
        ),
        _react2.default.createElement(
          "div",
          { className: "cx-alert__content" },
          children
        ),
        displayCloseButton && _react2.default.createElement(
          "span",
          { className: "cx-alert__dismiss", onClick: this.handleCloseClick },
          _react2.default.createElement(_IconClose2.default, null)
        )
      );
    }
  }]);

  return Alert;
}(_react2.default.Component);

Alert.propTypes = {
  /** Child markup to render inside the alert. */
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array]),

  /** Set to true to display a close button. */
  displayCloseButton: _propTypes2.default.bool,

  /** Globally unique and descriptive HTML ID. Used by QA for automated testing. */
  htmlId: _propTypes2.default.string.isRequired,

  /** Function to run when the close button is clicked. */
  onCloseClick: _propTypes2.default.func,

  /** Alert type to display. Accepts `info`, `warning`, `danger`, or `success`. */
  type: _propTypes2.default.oneOf(["info", "warning", "danger", "success"]).isRequired
};
Alert.defaultProps = {
  displayCloseButton: false
};
exports.default = Alert;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/Alert/Alert.js
// module id = 496
// module chunks = 0